import React from "react";

export default ({ color, size }) => (
  <svg xmlns="http://www.w3.org/2000/svg" width={size || 24} height={size || 24} viewBox="0 0 24 24">
    <path fill={color} d="M8,5.14V19.14L19,12.14L8,5.14Z" />
  </svg>
);
